import React from 'react'
import UploadForm from '../components/UploadForm'

const UploadPage = () => {
  return (
    <center>
      <h1>Upload a file </h1>
      <UploadForm />
    </center>
  )
}

export default UploadPage
